import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthService } from "../../../auth.service";

@Component({
  selector: "app-list-header",
  templateUrl: "./list-header.component.html",
  styleUrls: ["./list-header.component.css"],
})
export class ListHeaderComponent {
  @Input() title: BehaviorSubject<string> = new BehaviorSubject<string>("");

  @Input() searchPlaceholder = "";
  @Input() searchTerm: string | null = "";
  @Input() icon: string = "";
  @Output() searchTermChange = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<void>();
  @Output() addNewItem = new EventEmitter<void>();
  supervisor: boolean = false;
  constructor(private auth: AuthService) {}
  ngOnInit() {
    const titleValue = this.title.getValue();
    if (!this.icon) {
      switch (titleValue) {
        case "branches.title":
          this.icon = "business";
          break;
        case "departments.title":
          this.icon = "apartment";
          break;
        case "priorities.title":
          this.icon = "error";
          break;
        case "users.title":
          this.icon = "person";
          break;
        case "tags.title":
          this.icon = "label";
          break;
        case "status.title":
          this.icon = "check_circle";
          break;
      }
    }

    if (!this.title.getValue()) {
      this.title.next("");
    }
    if (!this.searchPlaceholder) {
      this.searchPlaceholder = "";
    }
    this.supervisor = this.auth.isSupervisor();
  }

  onSearchChange(value: string): void {
    this.searchTermChange.emit(value);
  }

  onClearSearch(): void {
    this.clearSearch.emit();
  }

  onAddNewItem(): void {
    this.addNewItem.emit();
  }
  get isSupervisor(): boolean {
    return this.auth.userdata.supervisor;
  }
}
